import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { getInitialUserState } from "./authAction";
import { RootState } from "../app/store";

export type User = {
  _id: string;
  email: string;
  userType: string;
  userVerified: boolean;
  subscriptionStatus?: string;
  firstName: string;
  lastName: string;
  avatar: string;
};

const initialUserState = getInitialUserState();

export const authSlice = createSlice({
  name: "auth",
  initialState: initialUserState,
  reducers: {
    login: (state, action) => {
      state._id = action.payload.user._id;
      state.email = action.payload.user.email;
      Cookies.set("token", action.payload.token, { expires: 1 });
    },
    logout: (state) => {
      state._id = "";
      state.email = "";
      state.userType = "";
      state.userVerified = false;
      state.firstName = "";
      state.lastName = "";
      state.avatar = "";
      Cookies.remove("token");
      Cookies.remove("verifyToken");
      Cookies.remove("firstName");
      Cookies.remove("email");
      Cookies.remove("encryptedOtp");
    },
    setUserType: (state, action) => {
      state.userType = action.payload.userType;
      state.userVerified = action.payload.userVerified;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.avatar = action.payload.avatar;
    },
    setUserVerified: (state, action) => {
      state.userVerified = action.payload;
    },
  },
});

export default authSlice.reducer;

export const { login, logout, setUserType, setUserVerified } =
  authSlice.actions;

// Selectors - Single source of truth for auth state
export const selectIsAuthenticated = (state: RootState) => !!state.auth._id;
export const selectUser = (state: RootState) => state.auth;
export const selectUserType = (state: RootState) => state.auth.userType;
export const selectUserVerified = (state: RootState) => state.auth.userVerified;
